<script setup lang="ts">

import ButtonInput from "@/components/inputs/Button.vue";
import Translator from '@/utils/common/Translator'
import {onMounted, onUnmounted, ref, watch} from "vue";
import LogoIcon from "@/components/icons/navBarIcons/LogoIcon.vue";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import type {QInput} from "quasar";
import NamaIcon from "@/components/icons/NamaIcon.vue";

let emit = defineEmits(['signInClicked', 'forgotPasswordClicked','logoRightClick']);

const username = ref("");
const isUsernameValid = ref(true);
const password = ref("");
const isPasswordValid = ref(true);
const canShowPassword = ref(false);
const staySignedIn = ref(false);
const usernameRef = ref<QInput>();
const passwordRef = ref<QInput>();
watch(() => username.value + password.value, () => {
  if (username.value)
    isUsernameValid.value = true;
  if (password.value)
    isPasswordValid.value = true;
  if (password.value === "crmpwd")
    LoginUtils.showLoginByQR();
})
function onSignInClick() {
  if (!validateSignIn())
    return;
  emit('signInClicked', username.value, password.value, staySignedIn.value)
}

function onEnterDown() {
  if (!username.value) {
    usernameRef.value?.focus();
  } else if (!password.value) {
    passwordRef.value?.focus();
  } else {
    if (!validateSignIn())
      return;
    emit('signInClicked', username.value, password.value, staySignedIn.value)
  }
}

function onForgotPasswordClick() {
  if (!validateForgotPassword())
    return;
  emit('forgotPasswordClicked', username.value);
}

function validateSignIn(): boolean {
  isUsernameValid.value = Boolean(username.value)
  isPasswordValid.value = Boolean(password.value)
  return isUsernameValid.value && isPasswordValid.value;
}

function validateForgotPassword(): boolean {
  isUsernameValid.value = Boolean(username.value)
  return isUsernameValid.value;
}

let wnd = window as any;
onMounted(() => {
  wnd.loginByUserAndPassword = (user: string, pwd: string) => {
    username.value = user;
    password.value = pwd;
    onSignInClick();
  }
  wnd.updatePassword = (pwd) => {
    password.value = pwd;
  }
  wnd.showLoginByQR = () => {
    LoginUtils.genQRCodeForMPSLogin((pwd) => {
      username.value = "admin";
      password.value = pwd;
      onSignInClick();
    })
  }
  wnd.showLoginByQRNoUser = () => {
    LoginUtils.showLoginByQR();
  }
});
onUnmounted(() => {
  wnd.loginByUserAndPassword = null;
  wnd.updatePassword = null;
  wnd.showLoginByQR = null;
  wnd.showLoginByQRNoUser = null;
})
function onLogoRightClick(){
  emit("logoRightClick");
}
</script>

<template>
  <div class="tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-flex-col">
    <div class="tw-w-1/2 tw-h-3/4 tw-flex tw-justify-between tw-items-center tw-flex-col mobile:tw-w-full mobile:tw-h-auto">
      <div class="tw-w-full tw-flex tw-justify-center mobile:tw-hidden">
        <LogoIcon width="272" height="94" is-dark-light @contextmenu="onLogoRightClick"/>
      </div>
      <div class="tw-w-full tw-flex tw-justify-center tw-flex-col">
        <h2 class="tw-text-center tw-text-primary-light tw-text-4xl tw-mb-10 tw-font-bold dark:tw-text-gray-200">{{ Translator.translateId("signIn") }}</h2>
        <div class="tw-w-full tw-flex  tw-flex-col">
          <q-input
            input-class="nama-input-class !tw-rounded-xl"
            outlined
            class="nama-customize-dense-input nama-focused-input nama-field-input !tw-rounded-xl"
            :class="{'tw-border-red-600': !isUsernameValid}"
            v-model="username"
            :placeholder="Translator.translateId('username')"
            :error="!isUsernameValid"
            @keyup.enter="onEnterDown"
            ref="usernameRef">
            <template v-slot:prepend>
              <NamaIcon default-icon="nm-user"/>
            </template>
          </q-input>
          <q-input
            input-class="nama-input-class"
            outlined
            class="nama-customize-dense-input nama-focused-input nama-field-input"
            :class="{'tw-border-red-600': !isPasswordValid}"
            v-model="password"
            :type="canShowPassword?'text':'password'"
            :placeholder="Translator.translateId('password')"
            :error="!isPasswordValid"
            autocomplete="off"
            @keyup.enter="onEnterDown"
            ref="passwordRef">
            <template v-slot:prepend>
              <NamaIcon default-icon="nm-lock"/>
            </template>
            <template v-slot:append>
              <NamaIcon class="tw-cursor-pointer" @click="canShowPassword = !canShowPassword"
                        :default-icon="canShowPassword?'visibility':'visibility_off'"/>
            </template>
          </q-input>
          <ButtonInput id="loginBtn" :text="Translator.translateId('signIn')" @click="onSignInClick"/>
          <div class="tw-my-2 tw-flex tw-items-center mobile:tw-my-3 tw-w-fit">
            <input id="stay-sign-in" type="checkbox" class="tw-cursor-pointer tw-text-gray-500 tw-rounded-sm focus:tw-ring-0" v-model="staySignedIn"/>
            <label for="stay-sign-in" class="tw-ms-1 tw-text-md tw-w-full tw-cursor-pointer tw-font-bold dark:tw-text-namaFontColor-dark">{{
                Translator.translateId("rememberLogin")
              }}</label>
          </div>
          <a href="#" class="tw-underline tw-font-bold tw-w-fit dark:tw-text-namaFontColor-dark"
             @click.prevent="onForgotPasswordClick">{{ Translator.translateId("forgotPassword") }}</a>
        </div>
      </div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<style scoped>

</style>
